import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#fff",
    },
    secondary: {
      main: "#4fc3f7",
    },
    text: {
      primary: "#fff",
      secondary: "#4fc3f7",
      disabled: "#999",
    },
  },
  typography: {
    fontFamily: "'Montserrat', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
});

export default theme;